import { createReducer } from '../../app/common/util/reducerUtil';
import { GET_CAPPING_LIMIT, LIMIT_UPDATED } from './LimitConstants';

const initialState = {};

export const limitUpdated = (state, payload) => {
  return {
    ...state,
    update: payload,
  }
};

export const getCappingLimitsForUser = (state, payload) => {
  return {
    ...state,
    limit: payload,
  }
};

export default createReducer(initialState, {
  [LIMIT_UPDATED]: limitUpdated,
  [GET_CAPPING_LIMIT]: getCappingLimitsForUser,
});